import { useContext } from 'react';
import { useObjectAccessModal } from '@/components/ObjectAccess';
import { ObjectAccessButton, SkeletonAccess } from '@/components/ObjectAccess/Button';
import { ObjectAccessContainer } from '@/containers/ObjectAccess/ObjectAccessContainer';
import { FolderLoadingContext, FolderStateContext } from '@/containers/Workspace.Folder/Context';

type Props = unknown;

export const Access = (props: Props) => {
  const isLoading = useContext(FolderLoadingContext);

  return isLoading
    ? <SkeletonAccess />
    : <InteractiveAccess />;
};

Access.displayName = 'Folder.Header.Access';

const InteractiveAccess = (props: Props) => {
  const state = useContext(FolderStateContext);
  const [toggleAccessModal, ObjectAccessModal] = useObjectAccessModal();

  return (
    <>
      <ObjectAccessButton
        count={state.meta.accessCount}
        onClick={toggleAccessModal} />
      <ObjectAccessContainer objectId={state.object.id} workspaceId={state.object.workspaceId}>
        <ObjectAccessModal />
      </ObjectAccessContainer>
    </>
  );
};

InteractiveAccess.displayName = 'Folder.Header.Access.Interactive';